import {type GeocodedAddress} from '@/utils/googleAutocomplete';

export type GeocodeOutcome =
  | {status: 'incomplete'}
  | {status: 'single'; address: GeocodedAddress}
  | {status: 'multiple'; candidates: GeocodedAddress[]};

export const resolveGeocodeOutcome = (results: GeocodedAddress[]): GeocodeOutcome => {
  if (results.length === 0) return {status: 'incomplete'};
  if (results.length === 1) return {status: 'single', address: results[0]};
  return {status: 'multiple', candidates: results};
};
